function generateRandomString(length) {
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const limit = 256 - (256 % characters.length);
  let result = "";
  while (result.length < length) {
    const bytes = crypto.getRandomValues(new Uint8Array(length));
    for (let i = 0; i < bytes.length && result.length < length; i++) {
      if (bytes[i] < limit) result += characters.charAt(bytes[i] % characters.length);
    }
  }
  const epochTime = Date.now();
  return result + epochTime;
}

export default generateRandomString;